import modal from "./modal";
import "./index.less";
import {
	EVENT_SET_VALUE,
	EVENT_GET_VALUE,
	EVENT_SEND_VALUE,
	FIELD_TEMPLATES
} from "constants.js";
import { find } from "lodash";
import { idsMatch } from "../../../utils/valueUtilities";

export class Controller {
	constructor($uibModal) {
		this._uibModal = $uibModal;
	}

	$onInit() {
		this._eventBus = this.reportScope.events;
	}

	getSelectionFields() {
		const result = (this.lookup?.data ?? []).reduce((fields, field) => {
			if(field.Template === FIELD_TEMPLATES.Selection) {
				fields.push(field);
			}

			return fields;
		}, []);

		return result;
	}

	findFieldDataItemById(field, selectedId) {
		const data = field?.Data ?? [];
		const directMatch = data.find(item => idsMatch(item.Id, selectedId));

		if(directMatch) {
			return directMatch;
		}

		const nestedMatch = data.find((item) => {
			return (item?.Entities ?? []).some((entry) => idsMatch(entry.Entity?.Id, selectedId));
		});

		return nestedMatch;
	}

	getSelectedValues(fields = this.getSelectionFields()) {
		const selectedValuePromises = fields.reduce((promises, field) => {
			promises.push(new Promise((resolve) => {
				const requestId = `area-selector-${field.Id}-${Date.now()}`;
				let resolved = false;
				const handles = {};

				handles.registration = this._eventBus.register(EVENT_SEND_VALUE(requestId), (e, params) => {
					if(resolved) {
						return;
					}

					resolved = true;
					clearTimeout(handles.timeout);
					this._eventBus.unregister(handles.registration);

					const payload = params.value?.[0] ?? {};
					const selectedId = payload.DataId ?? payload.EntityId ?? payload.Id;
					const selectedItem = this.findFieldDataItemById(field, selectedId);

					resolve(selectedItem ? {
						Id: selectedItem.Id,
						Name: selectedItem.Name ?? selectedItem.Code ?? payload._code,
						fieldId: field.Id
					} : null);
				});

				if(resolved) {
					this._eventBus.unregister(handles.registration);
					return;
				}

				handles.timeout = setTimeout(() => {
					if(resolved) {
						return;
					}

					resolved = true;
					this._eventBus.unregister(handles.registration);
					resolve(null);
				}, 250);

				this._eventBus.trigger(EVENT_GET_VALUE(field.Id), { id: requestId });
			}));

			return promises;
		}, []);

		return Promise.all(selectedValuePromises).then(values => {
			return values.reduce((selectedValues, value) => {
				if(value) {
					selectedValues.push(value);
				}

				return selectedValues;
			}, []);
		});
	}

	activateModal() {
		const selectionFields = this.getSelectionFields();

		this.getSelectedValues(selectionFields)
			.then((selectedValues) => {
				this._uibModal
					.open({
						component: "mapModal",
						size: "lg",
						resolve: {
							lookup: () => ({
								...this.lookup,
								data: selectionFields
							}),
							selectedValues: () => selectedValues
						}
					})
					.result.then(selection => {
						selectionFields.forEach(field => {
							const value = find(selection, s => s.fieldId === field.Id);

							if(value?.Id)
								this._eventBus.trigger(EVENT_SET_VALUE(field.Id), { value });
						});
					});
			});
	}
}

const deps = [modal];

export default angular
	.module("vesl.components.field-helpers.area-selector", deps)
	.component("areaSelector", {
		template: `
      <button type="button"
        class="btn btn-default"
        uib-tooltip="Map"
        ng-disabled="$ctrl.lookup.disabled"
        ng-click="$ctrl.activateModal()">
          <i class="zmdi zmdi-map ma-icon"></i>
      </button>
    `,
		controller: Controller,
		bindings: {
			lookup: "<",
			onSelect: "&"
		},
		require: {
			reportScope: "^^reportScope"
		}
	}).name;
